import { getTranslation, LANGUAGE, type TFnResources } from '@nfctron/nexus-core';
import { useIntl } from '@nfctron/nexus-react';

import common_cs from './i18n/cs';
import common_de from './i18n/de';
import common_en from './i18n/en';
import common_sk from './i18n/sk';

const resources = {
	[LANGUAGE.CZECH]: common_cs,
	[LANGUAGE.SLOVAK]: common_sk,
	[LANGUAGE.ENGLISH]: common_en,
	[LANGUAGE.GERMAN]: common_de,
	[LANGUAGE.FRENCH]: {} as any,
	[LANGUAGE.SPANISH]: {} as any,
	[LANGUAGE.RUSSIAN]: {} as any,
	[LANGUAGE.NORWEGIAN]: {} as any,
	[LANGUAGE.SWEDISH]: {} as any,
} as const satisfies TFnResources<any>;

export const useTranslationsScoped = () => {
	const language = useIntl();
	return getTranslation(language.languageId, resources);
};
